import gql from "graphql-tag";

export const DELETE_EQUIPMENTS = gql`
  mutation deleteEquipments($where: [DeleteEquipmentsInput!]!){
    deleteEquipments(where: $where)
  }
`;